/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslationService } from 'src/app/shared/service/translation.service';
import { DataServiceServiceProfile } from '../../services/profile-data-service.service';
import { SharingDataService } from 'src/app/shared/service/sharing-data.service';
import { LoadingSpinnerService } from 'src/app/shared/service/loading-spinner.service';
import { AppConstants } from 'src/app/shared/constants/constants';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AddCarComponent } from '../add-car/add-car.component';
import { CommonAlertModalModule } from 'src/app/components/common-alert-modal/common-alert-modal.module';


@Component({
  selector: 'app-fleet-card',
  templateUrl: './fleet-card.component.html',
  styleUrls: ['./fleet-card.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    NgxSkeletonLoaderModule,
    AddCarComponent,
    CommonAlertModalModule,
  ],
})
export class FleetCardComponent implements OnInit {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly translationService = inject(TranslationService);
  private readonly dataService = inject(DataServiceServiceProfile);
  private readonly sharingData = inject(SharingDataService);
  private readonly loadingSpinnerService = inject(LoadingSpinnerService);
  private readonly _destroyRef = inject(DestroyRef);

  noCarsFound: boolean = true
  defaultCarImage = "assets/images/alias/add-car.svg"
  car = "assets/images/car.png"
  carNew = "assets/images/car2.png"
  addCarClicked: boolean = false
  editCarClicked: boolean = false
  kebabMenuClicked: boolean = false
  showIndex: number = 0
  isDeleteModalOpen: boolean = false;
  carList: any = null;
  title: string = 'BP_LM_CONFIRM_DELETE_TITLE';
  message: string = '';
  cancelBtnTitle: string = AppConstants.COMMON_BUTTON_LABELS.CANCEL;
  actionBtnTitle: string = AppConstants.COMMON_BUTTON_LABELS.CONFIRM;
  actionType: string = 'delete-fleet';
  cardHovered: boolean = false
  translationData: any
  carAddedSuccessfully: boolean = false
  loader: boolean = true
  vin: string = ''
  editCarDetails: any;
  public buttonNames: any = AppConstants.COMMON_BUTTON_LABELS;
  public placeholderObject: any = '';

  // All output emitters go here
  @Output() carCountEmitter = new EventEmitter<any>();
  @Output() public componentEmitter = new EventEmitter<any>();
  @Output() public editCarDetailsEmitter = new EventEmitter<any>()

  ngOnInit(): void {
    this.fetchFleetList();
    this.sharingData.getCardAdded()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((data) => {
        if (data) {
          this.fetchFleetList();
        }
      });
  }
  cancelClicked(event: any) {
    if (event) {
      this.addCarClicked = false
      this.editCarClicked = false
    }
  }
  fetchFleetList() {
    // this.loadingSpinnerService.show()
    this.dataService.getFleetList().subscribe((data: any) => {
      this.loadingSpinnerService.hide()
      this.loader = false
      this.noCarsFound = false
      this.carList = data.body
      this.carCountEmitter.emit(data.body?.length)
    })
  }
  addCar() {
    this.addCarClicked = true
    this.editCarDetails = null
    this.cdr.markForCheck();
  }
  kebabMenu(i: any, event: any) {
    this.showIndex = i
    this.message = "BP_PM_DELETE_FLEET_MESSAGE"
    if (this.carList) {
      this.placeholderObject = {
        placeholderCar: this.carList[i]?.carName ? this.carList[i].carName : this.carList[i]?.vin
      }
      event.stopPropagation()
      this.kebabMenuClicked = !this.kebabMenuClicked
    }
  }
  closeMenu() {
    this.kebabMenuClicked = false
  }
  userAction(event: any) {
    if (event.action && event.actionType === this.actionType) {
      this.loadingSpinnerService.show()
      this.isDeleteModalOpen = false;
      this.dataService.deleteCarFromFleet(this.vin).subscribe(() => {
        this.fetchFleetList()
        this.loadingSpinnerService.hide()
        this.componentEmitter.emit('fleet-car')
        this.sharingData.setToasterToBeDisplayed(true)
        this.cdr.markForCheck();
      })
    } else {
      this.isDeleteModalOpen = false;
    }
  }

  hoverOnCard(i: any, event: any) {
    this.cardHovered = true
    this.showIndex = i
    event.stopPropagation()
  }
  mouseOutFromCard(i: any) {
    this.cardHovered = false
    this.showIndex = i
    this.kebabMenuClicked = false
    this.cdr.markForCheck();
  }
  deleteFleet(vin: string, i: number) {
    if (this.carList) {
      this.vin = vin
      this.isDeleteModalOpen = true;
      this.showIndex = i
      this.message = 'BP_PM_DELETE_FLEET_MESSAGE'
      this.placeholderObject = {
        placeholderCar: this.carList[i]?.carName ? this.carList[i]?.carName : this.carList[i]?.vin
      }
    }
  }

  editCar(data: any) {
    this.editCarClicked = true
    this.editCarDetails = data
    this.editCarDetailsEmitter.emit(data)
  }


}
